import Link from 'next/link';

import { buildWebsiteUrl } from '@repo/utils/url';

import { Banner, BannerItem } from './types';

const startingDate = new Date('2025-04-29T00:00:00+01:00');
const endingDate = new Date('2025-05-09T17:00:00+01:00');

const LANDING_PAGE_PATHNAME = '/great-design-starts-in-kittl';
const LANDING_PAGE_LINK_URL = buildWebsiteUrl(LANDING_PAGE_PATHNAME);
const BLOG_LINK_URL = buildWebsiteUrl(
  '/article/limited-time-offer-add-editors-for-free'
);

export const getBannerItem = (pathname: string): BannerItem => {
  const link =
    pathname === LANDING_PAGE_PATHNAME ? BLOG_LINK_URL : LANDING_PAGE_LINK_URL;

  return {
    key: 'bannerWorkspacesAsTeamsRelease',
    description: (
      <span>
        <Link href={link} target="_blank">
          Save up to $500 with your Team
        </Link>{' '}
        🎉 Invite up to 6 Free Editors. Until May 9th only
      </span>
    ),
    descriptionMobile: (
      <span>
        <Link href={link}>Save up to $500 with your Team</Link> 🎉 Ends May 9th
      </span>
    ),
  };
};

export const announcementBanner: Banner = {
  // We save all previous values here to not duplicate them accidentally
  // id: 'bannerAiX1',
  // id: 'bannerAiImagegenV2',
  // id: 'bannerAiCreditChange',
  // id: 'bannerBlackFriday',
  // id: 'bannerJan15Launch',
  // id: 'bannerJan15Features',
  // id: 'bannerWorkspacesAsTeams',
  id: 'bannerWorkspacesAsTeamsRelease',
  starts: startingDate,
  ends: endingDate,
  getItem: getBannerItem,
  visibleFor: 'allUsers',
};
